/**
 * plancampus.js
 */

// Import
import "./plancampus.scss";
import $ from 'jquery';

$(document).ready(function() {
    $('#plan-campus').on('click', function(e) {
        const hasCoordonnees = e.target.classList.contains('plan-coordonnees');
        const clickedID = e.target.id;
        if (!hasCoordonnees && clickedID != "parking" && clickedID != "velos"){
            location.href = 'https://plancampus.uqam.ca'
        }
    });
});
